package io.horion.cv.models

import androidx.compose.runtime.Composable
import org.jetbrains.compose.web.css.CSSNumericValue
import org.jetbrains.compose.web.css.CSSUnitLengthOrPercentage

data class ExtraSection(
    val id: String,
    val title: String,
    val collapsedWidth: CSSNumericValue<out CSSUnitLengthOrPercentage>,
    val content: @Composable () -> Unit,
    val personalizedType: PersonalizedSectionType? = null,
    val descriptionState: DescriptionState? = null
)
